import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ProfileService from "./profileService";
import { ProfileDTO } from "../../dtos/profile";


// Define initial state
const initialState = {
  profileDetails: {
    pharmacy: null,
    user: null,
  },
  profileId: "",
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: "",

  isProfileLoading: false,
  isProfileLoadingError: false,
};


// export const AddProfile = createAsyncThunk(
//   "/api/pharmacy/profile/add",
//   async (profile: AddProfileDTO, thunkAPI) => {
//     try {
//       return await ProfileService.AddProfile(profile);
//     } catch (error: any) {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();
//       return thunkAPI.rejectWithValue(message);
//     }
//   }
// );

export const getProfileData = createAsyncThunk(
  "/pharmacy/get_profile",
  async (pharmacyId: any, thunkAPI) => {
    try {
      const response:any = await ProfileService.getProfile(pharmacyId);
      return {
        pharmacy: response?.pharmacy,
        user: response?.user,
      };
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const editProfile = createAsyncThunk(
    "profile/edit",
    async (profile: ProfileDTO, thunkAPI) => {
      try {
        return await ProfileService.editProfile(profile);
      } catch (error: any) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return thunkAPI.rejectWithValue(message);
      }
    }
  );

export const profileSlice = createSlice({
  name: "profileSlice",
  initialState,
  reducers: {
    reset: () => initialState,
    changeProfileId: (state, action) => {
      state.profileId = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getProfileData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getProfileData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.profileDetails = {
          pharmacy: action.payload.pharmacy,
          user: action.payload.user,
        };
        state.message = "";
      })
      .addCase(getProfileData.rejected, (state:any, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

// Export actions and reducer
export const { reset, changeProfileId } = profileSlice.actions;
export default profileSlice.reducer;
